import config from "../config"
const baseUrl = config.base_url + "z_farm_buy_goods/"
export default {
    page: {
        url: baseUrl + "page",
        type: "post",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    loadFromWechat: {
        url: baseUrl + "loadFromWechat",
        type: "post",
    }
}
